import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IBookmarksState } from './model';

const selectModalFeat = createFeatureSelector<Readonly<IBookmarksState>>('bookmarks');

export const selectTicket = createSelector(selectModalFeat, (state: IBookmarksState) => state?.ticket);

export const selectBookmarks = createSelector(selectModalFeat, (state: IBookmarksState) => state.bookmarks);
